module.exports = __webpack_public_path__ + "resources/react-app/img/tipigo-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tipigo-logo.png
// module id = 1157
// module chunks = 0